import React from 'react';

// Reset at each taxon in compound references; authors and ranks remain roman.
export const SciName = ({ name, className = '' }) => {
  if (!name) return null;
  const segments = String(name).split(/(\s*;\s*|\s+\/\s+|\s+×\s+(?=[A-Z]))/);
  return <span className={className}>{segments.map((segment, segmentIndex) => {
    if (segmentIndex % 2) return segment;
    let words = 0, author = false, rankEpithet = false;
    return <React.Fragment key={segmentIndex}>{segment.split(/(\s+)/).map((token, i) => {
      if (!token.trim()) return token;
      const rank = /^(subsp\.|nothosubsp\.|ssp\.|var\.|f\.|spp\.|sp\.)$/.test(token);
      const hybrid = token === '×';
      const lowercase = /^[a-z][a-z-]*$/.test(token);
      const italic = !author && !rank && !hybrid && (words === 0 || (words === 1 || rankEpithet) && lowercase);
      if (rank && !author) rankEpithet = !['spp.','sp.'].includes(token);
      else if (!hybrid) { if (!italic) author = true; words++; rankEpithet = false; }
      return italic ? <em key={i} className="italic">{token}</em> : <span key={i} className="not-italic">{token}</span>;
    })}</React.Fragment>;
  })}</span>;
};
